<template>
    <div class="works-detail" v-if="isShow">
        <div class="left-right-content clearfix">
            <div class="c-left">
                <div class="article-center-cont">
                    <div v-html="videoHtml" class="iframe-h"></div>
                    <div v-if="course.courseSeries == 1" class="plays-btns">
                        <span class="curp" v-if="proItem" @click="getItems(proItem.id)" :title="proItem.sectionName">
                            <i class="el-icon-arrow-left"></i>
                            <span class="cur-name">上一节：{{proItem.sectionName}}</span>
                        </span>
                        <span class="curr" v-else>第一节</span>
                        <span class="curp" v-if="nextItem"  @click="getItems(nextItem.id)" :title="nextItem.sectionName">
                            <span class="cur-name">下一节：{{nextItem.sectionName}}</span>
                            <i class="el-icon-arrow-right"></i>
                        </span>
                        <span class="curr" v-else>最后一节</span>
                    </div>

                </div>


                <!-- 评论 -->
                <!--<div class="pro-work-item clearfix" style="border-top: 5px solid #f6f6f6;">
                    <div class="item-infoes same-left">
                        <talkPart :objType="7" :objId="objId" v-if="isReload && isMounted" :loadShow="true" :isOperate="false" :isHeaderOperate="true"></talkPart>
                    </div>
                </div>-->
                <!-- 评论 -->

            </div>
            <div class="c-right">
                <div class="one-item">
                    <div class="detail-userinfo">
                        <router-link
                                :to="{ path: '/home', query: { userId: userInfo.userId } }"
                                class="avatar-f"
                        ><img :src="userInfo.imgUrl" alt=""
                        /></router-link>
                        <div class="user-name">
                            <router-link
                                    :to="{ path: '/home', query: { userId: userInfo.userId } }"
                            >{{ userInfo.userName }}</router-link
                            >
                        </div>
                        <div class="chenghao">{{ userInfo.signature }}</div>
                        <div class="qianming">{{ userInfo.introduction }}</div>
                        <div class="btns" v-if="isLogin && userInfo.userId != loginUserId">
                            <el-button class="btn wgz-btn" v-if="userInfo.followStatus==0"  @click="doFollow(userInfo.userId)"><i class="el-icon-plus"></i> 关注</el-button>
                            <el-button class="btn" v-else-if="userInfo.followStatus==1" @click="undoFollower(userInfo.userId)">已关注</el-button>
                            <el-button class="btn" v-else-if="userInfo.followStatus==2" @click="undoFollower(userInfo.userId)">互相关注</el-button>

                            <el-button class="btn wgz-btn" v-if="friendStatus == 4"  @click="addFriend()"><i class="el-icon-plus"></i> 加好友</el-button>
                            <!--<el-button class="btn" @click="toChart(userInfo.userId)" v-else-if="friendStatus == 2">发消息</el-button>-->
                            <el-button class="btn" v-else-if="friendStatus == 1" style="cursor:auto">请求中</el-button>
                        </div>
                        <ul class="much-list clearfix">
                            <li>
                                <span class="tit">课程</span>
                                <span class="count">{{userInfo.courseCount}}</span>
                            </li>
                            <li>
                                <span class="tit">报名</span>
                                <span class="count">{{userInfo.courseSin}}</span>
                            </li>
                            <li>
                                <span class="tit">点赞</span>
                                <span class="count">{{userInfo.courseLike}}</span>
                            </li>

                            <!--<li>
                                <router-link
                                        target="_blank"
                                        :to="{
                    path: '/home/zuopin',
                    query: { userId: userInfo.userId }
                  }"
                                >
                                    <span class="tit">作品</span>
                                    <span class="count">{{ userInfo.productionsCount }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                        target="_blank"
                                        :to="{
                    path: '/home/wenzhang',
                    query: { userId: userInfo.userId }
                  }"
                                >
                                    <span class="tit">文章</span>
                                    <span class="count">{{ userInfo.archivesCount }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                        target="_blank"
                                        :to="{
                    path: '/home/fensi',
                    query: { userId: userInfo.userId }
                  }"
                                >
                                    <span class="tit">粉丝</span>
                                    <span class="count">{{ userInfo.followersCount }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                        target="_blank"
                                        :to="{
                    path: '/home/guanzhu',
                    query: { userId: userInfo.userId }
                  }"
                                >
                                    <span class="tit">关注</span>
                                    <span class="count">{{ userInfo.followingsCount }}</span>
                                </router-link>
                            </li>-->
                        </ul>
                    </div>
                </div>
<!--                <div class="one-item">-->
<!--                    <div class="one-title">-->
<!--                        其他作品-->
<!--                        <i class="el-icon-refresh-right shuaxin" @click="other"></i>-->
<!--                    </div>-->
<!--                    <div class="works-list">-->
<!--                        <router-link-->
<!--                                :to="{ path: '/worksdetail', query: { id: item.id } }"-->
<!--                                target="_blank"-->
<!--                                class="item"-->
<!--                                v-for="(item, index) in otherProductionList"-->
<!--                                :key="index"-->
<!--                        >-->
<!--                            <div class="work-img-f">-->
<!--                                <img :src="item.productionCover" alt="" />-->
<!--                            </div>-->
<!--                            <div class="work-title">{{ item.productionName }}</div>-->
<!--                        </router-link>-->
<!--                    </div>-->
<!--                </div>   -->
                <div v-if="course.courseSeries == 1" class="course-list-duo">
                    <list-item
                        v-for="(item,index) in sections"
                        :key="item.id"
                        :sections="item"
                        :isOpen="secParId == item.id || (typeof (secId) == 'undefined'&& index==0 )"
                        :formByType="2"
                        :showTagType="showTagType"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import { mapState } from "vuex";
    import updateTdk from "@/utils/tdk";
    import productionApi from '@/api/production'
    import axios from 'axios';
    import vue from 'vue';
    vue.prototype.$axios = axios;
    import userInfoApi from '@/api/userInfo'
    import homeApi from '@/api/home'
    import apiService from '@/api/index'
    import videoApi from '@/api/video'
    import listItem from './listItem'
    export default {
        components: {
            listItem
        },
        data () {
            return {
                headTitle: "付费观看",
                headKeywords: "keywords---rrdh",
                headDesc: "description---rrdh",
                isMounted: false, //for control not ssr render

                friendStatus:-1,
                ccReload:true,
                otherTotal:0,
                aboutTotal:0,
                isShow:false,
                isLogin: false,
                loginUserId:0,
                objId:0,
                isReload:true,
                isReloadLikeFlag: true,
                videoUrl:"",
                ccsrc: "1",
                ccPic:"",
                textCon: '',
                activitiesAnd: false,
                userInfo:{},
                videoHtml:'',
                course:{},
                courseStatus:0,
                sections: [],
                showTagType:2,  //1未登录 3 未发布 2 未报名
                secId:0,
                secParId:0,
                classList:[],
                proItem:null,
                nextItem:null,
            }
        },
        computed: {
            ...mapState(["videoDetail"])
        },
        tdk() {
            return {
                title: this.headTitle,
                description: this.headDesc,
                keywords: this.headKeywords,
                ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
            };
        },

        serverPrefetch() {
            return this.fetchData();

        },
        destroyed() {
            this.$store.commit("SET_VIDEO_DETAIL", { detail: null });
        },
        beforeMount(){
            if(this.$route.params.courseId == undefined){
                this.$message.error("数据对象获取失败，请联系管理员")
                return false
            }
        },
        mounted() {
            this.isMounted = true;
            const alreadyIncremented = !!this.videoDetail;
            if (!alreadyIncremented) {
                this.fetchData().then(
                    setTimeout(()=>{
                        this.initData()
                    },2500)
                );
            } else {
                setTimeout(()=>{
                    this.initData()
                },2500)
            }
            // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
            // window.addEventListener('unload', e => this.unloadHandler(e))
        },
        // created(){
        //   this.setPlayerCallBack();
        // },
        // destroyed() {
        //   window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
        //   window.removeEventListener('unload', e => this.unloadHandler(e))
        // },
        methods:{
            setSeo() {
                if(this.videoDetail.id !=null){
                    let secId = this.$route.query.secId

                    if(this.videoDetail.courseSeries == 1){
                        if(typeof (secId) == 'undefined' || secId == ''){
                            this.headTitle = this.videoDetail.sections[0].classes[0].sectionName+"——人人动画网【官网】";
                        }else {
                            this.videoDetail.sections.forEach(itemF =>{
                                try {
                                    itemF.classes.forEach(itemC =>{
                                        if(secId == itemC.id){
                                            this.headTitle = itemC.sectionName+"——人人动画网【官网】";
                                            throw Error();
                                        }
                                    })
                                } catch (e) {
                                }
                            })
                        }

                        this.headKeywords = this.videoDetail.courseIntroduction;
                        let desc = this.videoDetail.mainContent.replace(/<\/?.+?>/g,"").trim()
                        this.headDesc =desc.substr(0,150);
                    }else{

                        this.headTitle = this.videoDetail.courseName+"——人人动画网【官网】";
                        this.headKeywords = this.videoDetail.courseIntroduction;
                        let desc = this.videoDetail.mainContent.replace(/<\/?.+?>/g,"").trim()
                        this.headDesc =desc.substr(0,150);
                    }
                }


            },
            fetchData(){
                let id = this.$route.params.courseId
                if(this.$route.params.courseId == undefined){
                    id=0
                }
                return this.$store
                    .dispatch("FETCH_VIDEO_DETAIL", {
                        id: id
                    })
                    .finally(() => {
                        this.$loading(false);
                        this.setSeo()
                        updateTdk.call(this);
                    });
            },
            setShowTagType(){
                let thiss = this
                thiss.showTagType = 4
            },
            initData(){
                let this_ = this

                this_.course  = this_.videoDetail
                this_.sections = this_.videoDetail.sections

                this_.classList = this_.videoDetail.classList

                if(this_.course.id !=null ){
                    this_.objId =parseInt(this_.course.id)


                    this_.loginUserId = 8
                    this_.isLogin = true

                    this_.showVideo()
                    this_.setShowTagType()
                }

            },
            showVideo(){
                let this_ = this
                window.ccH5PlayerJsLoaded = true;
                window.on_CCH5player_ready = this.onPlayerReady;

                if(this_.course.courseSeries == 0){
                    //单课节
                    if(this_.course.videoSource=='2'){
                        let html = this_.course.videoCode
                        this_.videoHtml = html
                    }else{
                        let html = '<iframe id="cciframe_'+this_.videoDetail.videoCcId+'" src="https://p.bokecc.com/playhtml.bo?vid='+this_.videoDetail.videoCcId+'&siteid=9D23FB9C216EB7C0&autoStart=true&playerid=2B0B9D320AC51E5F&playertype=1&isShare=true&newversion=true" allowfullscreen="true" frameborder="0" ></iframe>'
                        this_.videoHtml = html
                    }

                    this_.isShow = true
                }else{
                    //多课节
                    let secId = this.$route.query.secId
                    this.secId = secId
                    if(typeof (secId) == 'undefined' || secId == ''){
                        this_.setHtml(this_.course.sections[0].classes[0])

                        //默认第一节， 没有上一节，判断是否存在下一节
                        if(this_.course.sections[0].classes[1]){
                            this_.nextItem = this_.course.sections[0].classes[1]
                        }else{
                            if(this_.course.sections[1]){
                                this_.nextItem = this_.course.sections[1].classes[0]
                            }
                        }
                    }else {
                        this_.getItems(secId)
                    }
                }

                //作者信息
                userInfoApi.select(this_.course.creatorId).then(reUser => {
                    this_.userInfo = reUser.response
                })
            },

            getItems(id){
                let this_ = this
                try {
                    this_.classList.forEach((item,index)=>{
                        //与传入课节ID 相等
                        if(id == item.id){
                            if(index == 0){
                                this_.proItem = null
                            }else{
                                this_.proItem = this_.classList[index-1]
                            }
                            if(index == this_.classList.length -1){
                                this_.nextItem = null
                            }else {
                                this_.nextItem = this_.classList[index+1]
                            }

                            this_.secParId = item.parentSectionId
                            this_.setHtml(item)
                            throw Error();
                        }
                    })
                } catch (e) {
                }
            },

            setHtml(item){
                document.title = item.sectionName+"——人人动画网【官网】"
                let thiss = this
                let html =""
                //contentForm:"1",//1为视频；9为引用视频；10为通用代码
                if(item.contentForm == 10){
                    html = item.videoCode
                    thiss.videoHtml = html
                }else if(item.contentForm == 1){
                    html = '<iframe id="cciframe_'+item.videoId+'" src="https://p.bokecc.com/playhtml.bo?vid='+item.videoId+'&siteid=9D23FB9C216EB7C0&autoStart=true&playerid=2B0B9D320AC51E5F&playertype=1&newversion=true" allowfullscreen="true" frameborder="0" ></iframe>'
                    thiss.videoHtml = html
                }else if(item.contentForm == 9){
                    if(item.videoId.indexOf("iframe") >-1){
                        html = item.videoId
                        thiss.videoHtml = html
                    }else{
                        html = '<iframe id="cciframe_'+item.videoId+'" src="https://p.bokecc.com/playhtml.bo?vid='+item.videoId+'&siteid=9D23FB9C216EB7C0&autoStart=true&playerid=2B0B9D320AC51E5F&playertype=1&newversion=true" allowfullscreen="true" frameborder="0" ></iframe>'
                        thiss.videoHtml = html
                    }

                }

                window.scrollTo({
                    top:0,
                    behavior: "smooth"
                })

                thiss.isShow = true
            },
            toTop () {
                let el = document.getElementById('proAbout');

                let top= el.offsetTop

                window.scrollTo({
                    top: top-60,
                    behavior: "smooth"
                })
            },

            reloadModel(){
                let _this = this
                // 移除组件
                _this.isReload = false
                // 在组件移除后，重新渲染组件
                // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                _this.$nextTick(() => {
                    _this.isReload = true
                })
            },
            toLog(){
                this.$router.push({
                    path:'/login?callback=' + window.location.href,
                })

            } ,
            //转码没成功提示
            notStatus(){
                this.$message.error("视频转码中...请耐心等待")
            },
            //登录并跳转指定页面
            toLogWithNextPage(id){

                let url = "/worksdetail?id="+id
                let url2 = '/login?callback=' + "http://"+window.location.host+"/worksdetail?id="+id


                if(this.isLogin){
                    window.open(url, '_blank');
                }else{
                    window.open(url2, '_blank');
                }
            },
            reloadCCPart(){
                let thiss = this
                // 移除组件
                thiss.ccReload = false
                // 在组件移除后，重新渲染组件
                // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                thiss.$nextTick(() => {
                    thiss.ccReload = true
                })
            },



            getFriendStatus(){
                let _this=this;
                let url="/rrbi/friends/getFriendStatus?userId="+_this.course.creatorId+"&currentUserId="+_this.loginUserId+"&ti="+new Date().getMilliseconds();
                _this.$axios.get(url).then(function(result){
                    _this.friendStatus = result.data
                })
            },
            addFriend() {
                let _this = this;
                if (_this.global.isLogin) {
                    let url = '/rrbi/friends/add/' + _this.course.creatorId + "?ti=" + new Date().getMilliseconds();
                    _this.$axios.get(url).then(function (result) {
                        console.log(result)
                        if (result.data.response.code == 1) {
                            _this.$message.success(result.data.response.msg)
                            _this.friendStatus = 1
                        } else {
                            _this.$message.error(result.data.response.msg)
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped lang="less">
    @import "./detail.less";
    .pagintion-f {
        padding: 20px 0 40px;
        text-align: center;
    }
    .works-detail {
        padding-top: @NAVHEIGHT;
        .demand-play {
            .container {
                object {
                    embed {
                        width: 100% !important;
                        height: 100vh !important;
                    }
                }
                /deep/.ccH5playerBox {
                    margin: 5px auto;
                }
                /deep/.ccH5playerBox.ccH5PlayerBoxFixed {
                    margin: 0 !important;
                    padding: 0 !important;
                    width: 100% !important;
                    height: 100% !important;
                }
            }
            /deep/.ccH5Poster {
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .no-success-add {
                overflow: hidden;
                position: relative;
                margin: 5px auto;
                .img-fm {
                    width: 100%;
                }
                .no-play-icon {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin: -20px 0 0 -20px;
                    width: 40px;
                    height: 40px;
                    background-image: url(../../../assets/images/video_play_icon.png);
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    cursor: pointer;
                }
            }
        }
        .about-works {
            padding: 10px;
            line-height: 30px;
            color: #808080;
            font-size: 16px;
            background: #f6f6f6;
        }
    }
    .course-list-duo{
        padding: 10px;
        background: #fff;
    }
    .plays-btns{
        text-align: center;
        line-height: 24px;
        font-size: 14px;
        .curp{
            margin: 0 10px;
            color: #409EFF;
            cursor: pointer;
            .cur-name{
                overflow: hidden;
                display: inline-block;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 150px;
                vertical-align: middle;
            }
        }
        .curr{
            margin: 0 10px;
            cursor: no-drop;
        }
    }
    @media screen and (max-width: 750px) {
        .works-detail {
            .demand-play {
                .container {
                    /deep/.ccH5playerBox {
                        width: 100% !important;
                        height: 250px !important;
                    }
                }
                .no-success-add {
                    width: 100%;
                    // height: 250px;
                }
            }
            .c-right{
                display: block !important;
                width: 100% !important;
            }
        }
    }
    @media screen and (min-width: 751px) {
        .works-detail {
            .demand-play {
                .container {
                    /deep/.ccH5playerBox {
                        width: 300px !important;
                        height: 208px !important;
                    }
                }
                .no-success-add {
                    width: 300px;
                    // height: 208px;
                }
            }
        }
    }
    @media screen and (min-width: 1024px) {
        .works-detail {
            .demand-play {
                .container {
                    /deep/.ccH5playerBox {
                        width: 600px !important;
                        height: 416px !important;
                    }
                }
                .no-success-add {
                    width: 600px;
                    // height: 416px;
                }
            }
        }
    }
    @media screen and (min-width: 1250px) {
        .works-detail {
            .demand-play {
                .container {
                    /deep/.ccH5playerBox {
                        width: 640px !important;
                        height: 540px !important;
                    }
                }
                .no-success-add {
                    width: 640px;
                    // height: 540px;
                }
            }
        }
    }
    @media screen and (min-width: 1366px) {
        .works-detail {
            .demand-play {
                .container {
                    /deep/.ccH5playerBox {
                        width: 750px !important;
                        height: 520px !important;
                    }
                }
                .no-success-add {
                    width: 750px;
                    // height: 520px;
                }
            }
        }
    }
    //@import "../../../assets/less/stylePublic.less";
</style>
